import React from 'react'
import Namecard1 from './component/basic/namecard';
const App = () => {
  return <Namecard1 />;
};

export default App;
